import React from 'react';
import Collapsible from 'react-collapsible';

import { AccessOverviewHeading } from 'screens/AuditScreens';
import { AccessListItemNode } from '../AccessListItem';

import styles from './AccessOverview.module.scss';

interface AccessOverviewNodeProps {
  nodes: any;
  total: number;
  onViewAll: () => void;
  title: string;
  subtitleOpen: string;
  subtitleClosed: string;
  buttonMessage: string;
  isOpen?: boolean;
  handleTriggerClick: any;
}
export const AccessOverviewNode = ({
  nodes,
  total,
  onViewAll,
  title,
  subtitleOpen,
  subtitleClosed,
  buttonMessage,
  isOpen,
  handleTriggerClick,
}: AccessOverviewNodeProps) => {
  return (
    <Collapsible
      classParentString=""
      triggerTagName="div"
      triggerClassName={styles.trigger}
      triggerOpenedClassName={styles.trigger}
      openedClassName={styles.container}
      className={styles.container}
      contentOuterClassName={styles.contentOuter}
      contentInnerClassName={styles.contentInner}
      transitionTime={150}
      easing="ease-in-out"
      trigger={
        <AccessOverviewHeading
          title={title}
          subtitle={subtitleOpen}
          complete={total > 0 ? false : true}
          alternate
        />
      }
      triggerWhenOpen={
        <AccessOverviewHeading
          title={title}
          subtitle={subtitleClosed}
          complete={total > 0 ? false : true}
          alternate
        />
      }
      open={isOpen}
      handleTriggerClick={total > 0 ? handleTriggerClick : function () {}}
    >
      <div className={styles.bin}>
        {nodes.slice(0, 2).map((node: any, key: number) => (
          <AccessListItemNode key={key} node={node} buttonMessage={buttonMessage} />
        ))}
      </div>
      <div onClick={onViewAll} className={styles.viewAll}>
        View all {total.toLocaleString()} documents
      </div>
    </Collapsible>
  );
};
